export class AssignFacility {
    associationId: number;
    facilityToAddId: number;

    constructor(associationId: number, facilityToAddId: number) {
        this.associationId = associationId;
        this.facilityToAddId = facilityToAddId;
    }
}
